import {Tooltip} from "primereact/tooltip";
import {useRef} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {navigateToRouteAndHash} from "../../hooks/navigationHooks";
import {selectHasSpfTable} from "../../redux/objectParametersSlice";
import {InputSpecialPropertyFeaturesEditPanel} from "./InputSpecialPropertyFeatures";

export default function ValuesIconSpecialFeatures({tooltipRef}) {
    const hasSpfTable = useSelector(selectHasSpfTable);
    const ref = useRef(null);
    const navigate = useNavigate();
    const tooltip = hasSpfTable && (
        <Tooltip target={`.${tooltipRef}`} className="spf-tooltip">
            <InputSpecialPropertyFeaturesEditPanel disabled={true} compact={true} />
        </Tooltip>
    );
    return (
        <>
            {tooltip}
            <i
                ref={ref}
                className={`pi pi-info-circle tooltip-icon text-blue-500 ${tooltipRef}`}
                data-pr-position="top"
                onClick={() =>
                    navigateToRouteAndHash(navigate, "/object/inspection", "input_inspection_special_property_features")
                }
            />
        </>
    );
}
